function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  className: "a",
  d: "M57.3,163.516a3.717,3.717,0,1,0,3.717,3.717A3.721,3.721,0,0,0,57.3,163.516Zm0,5.841a2.124,2.124,0,1,1,2.124-2.124A2.127,2.127,0,0,1,57.3,169.357Zm0,0",
  transform: "translate(-47.904 -149.465)"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  className: "a",
  d: "M167.862,191.059H150.371a.8.8,0,0,0,0,1.593h17.491a.8.8,0,1,0,0-1.593Zm0,0",
  transform: "translate(-133.715 -174.088)"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  className: "a",
  d: "M57.3,261.848a3.717,3.717,0,1,0,3.717,3.717A3.721,3.721,0,0,0,57.3,261.848Zm0,5.841a2.124,2.124,0,1,1,2.124-2.124A2.127,2.127,0,0,1,57.3,267.689Zm0,0",
  transform: "translate(-47.904 -237.371)"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  className: "a",
  d: "M167.862,289.391H150.371a.8.8,0,0,0,0,1.593h17.491a.8.8,0,0,0,0-1.593Zm0,0",
  transform: "translate(-133.715 -261.994)"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  className: "a",
  d: "M167.862,387.727H150.371a.8.8,0,1,0,0,1.593h17.491a.8.8,0,1,0,0-1.593Zm0,0",
  transform: "translate(-133.715 -349.903)"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  className: "a",
  d: "M35.938,0H33.062a.8.8,0,0,0,0,1.593h2.876a3.1,3.1,0,0,1,3.094,3.094V49.6a3.1,3.1,0,0,1-3.094,3.094H4.687A3.1,3.1,0,0,1,1.593,49.6V4.687A3.1,3.1,0,0,1,4.687,1.593h25.4a.8.8,0,0,0,0-1.593H4.687A4.692,4.692,0,0,0,0,4.687V49.6a4.692,4.692,0,0,0,4.687,4.687H35.938A4.692,4.692,0,0,0,40.625,49.6V4.687A4.692,4.692,0,0,0,35.938,0Zm0,0",
  transform: "translate(0 0)"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  className: "a",
  d: "M58.384,365.725A.8.8,0,1,0,59.2,367.1a3.717,3.717,0,1,0-3.786,0,.8.8,0,1,0,.812-1.371,2.124,2.124,0,1,1,2.162,0Zm0,0",
  transform: "translate(-47.904 -325.277)"
});

function SvgExamen(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40.625,
    height: 54,
    fill: "black",
    viewBox: "0 0 40.625 54.287",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgExamen);
export default __webpack_public_path__ + "static/media/Examen.1892ba55.svg";
export { ForwardRef as ReactComponent };